import { DependencyList, useEffect } from "react";

import { DataUpdatesChannelName } from "@/common/realtime/dataUpdatesChannelName";
import {
  DataUpdatesHubClientMethodName,
  EntityType,
  OperationCountersDto,
} from "@/core/api/generated/v1";
import * as operationsSlice from "@/store/operation/operationsSlice";

import { useRealtimeDataUpdates } from "../../realtime/useRealtimeDataUpdates";
import { useAppSelector, useAppThunkDispatch } from "../../redux";
import { useTenantProfileV2 } from "../tenant/useTenantProfileV2";

export const useOperationsCounters = (params?: {
  deps?: DependencyList;
}): OperationCountersDto | undefined => {
  const tenantProfile = useTenantProfileV2();
  const thunkDispatch = useAppThunkDispatch();

  const counters = useAppSelector((x) => x.operations.counters);

  useEffect(() => {
    if (!counters) {
      thunkDispatch(operationsSlice.getCountersThrottle());
    }
  }, [counters, ...(params?.deps || [])]);

  useRealtimeDataUpdates({
    enabled: !!tenantProfile.tenantId,
    channelNames: [
      DataUpdatesChannelName.Entities(tenantProfile.tenantId, EntityType.AccessoryCheck),
      DataUpdatesChannelName.Entities(tenantProfile.tenantId, EntityType.VisualInspection),
      DataUpdatesChannelName.Entities(tenantProfile.tenantId, EntityType.DamageDetection),
      DataUpdatesChannelName.Entities(tenantProfile.tenantId, EntityType.DamageCostEvaluation),
      DataUpdatesChannelName.Entities(tenantProfile.tenantId, EntityType.RepairOperation),
      DataUpdatesChannelName.Entities(tenantProfile.tenantId, EntityType.WheelOperation),
      DataUpdatesChannelName.Entities(tenantProfile.tenantId, EntityType.Wash),
      DataUpdatesChannelName.Entities(tenantProfile.tenantId, EntityType.Maintenance),
    ],
    methodNames: [DataUpdatesHubClientMethodName.EntityChanged],
    handler: undefined,
    entityChangedHandler: (methodName, data) => {
      thunkDispatch(operationsSlice.getCountersThrottle());
    },
  });

  return counters;
};
